import { render, staticRenderFns } from "./TeamSection.vue?vue&type=template&id=3b771a9e&scoped=true&"
import script from "./TeamSection.vue?vue&type=script&lang=js&"
export * from "./TeamSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamSection.vue?vue&type=style&index=0&id=3b771a9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b771a9e",
  null
  
)

export default component.exports